import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import clients from './translations/clients';
import cards from './translations/cards';
import activity from './translations/activity';
import collections from './translations/collections';
import users from './translations/users';
import details from './translations/details';
import summary from './translations/summary';
import management from './translations/management';
import login from './translations/login';
import recover from './translations/recover';
import device from './translations/device';
import expirations from './translations/expirations';
import paymentLinks from './translations/paymentLinks';
import paymentMovements from './translations/paymentMovements';
import paymentLinksPosition from './translations/paymentLinksPosition';
import email from './translations/email';
import telephone from './translations/telephone';
import fraudPrevention from './translations/fraudPrevention';
import products from './translations/products';
import datepicker from './translations/datepicker';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
    en: {
        translation: {
            clients: clients.EN,
            cards: cards.EN,
            activity: activity.EN,
            collections: collections.EN,
            datepicker: datepicker.EN,
            users: users.EN,
            details: details.EN,
            summary: summary.EN,
            management: management.EN,
            login: login.EN,
            recover: recover.EN,
            device: device.EN,
            expirations: expirations.EN,
            paymentLinks: paymentLinks.EN,
            paymentMovements: paymentMovements.EN,
            paymentLinksPosition: paymentLinksPosition.EN,
            email: email.EN,
            telephone: telephone.EN,
            fraudPrevention: fraudPrevention.EN,
            products: products.EN,
            pagination: {
                total: 'Records',
                of: 'of',
                empty: 'No records found',
                recordsPerPage: 'Records per page',
                warning: `We can not charge more pages.<br />
                apply filters<br />
                to get more results.`
            },
            filter: {
                searchPlaceholder: 'Search...',
                search: 'Search',
                title: 'Filter',
                modal: {
                    title: 'Searching filters',
                    date: {
                        title: 'Date',
                        from: 'From date',
                        to: 'To date'
                    },
                    apply: 'Apply',
                    delete: 'Delete filters'
                }

            },
            buttons: {
                accept: 'Accept',
                confirm: 'Confirm',
                cancel: 'Cancel',
                continue: 'Continue',
                back: 'Back',
                block: 'Block',
                unblock: 'Unblock',
                recoverPassword: 'Recover password',
                unsubscribe: 'Unsubscribe',
                save: 'Save',
                discard: 'Discard changes',
                reportPayment: 'Report payment',
                reject: 'Reject',
                approve: 'Approve',
                login: 'Login',
                sendEmail: 'Send email',
                close: 'Close',
                editMail: 'Modify Mail',
                preview: 'Preview',
                program: 'Program',
                reset: 'Reset search',
                modify: 'Modify',
            },
            errors: {
                // eslint-disable-next-line quotes
                generalTitle: `Something did not go as expected`,
                generalDescription: 'We apologize. It was not possible to complete the operation.',
                user: 'The user already exist.',
                emailAlreadyExists: 'The entered email already exists for another user.',
                notFound: 'An error has ocurred when trying to load the client.',
                invalidPassword: 'The password must not contain personal data.',
                downloadFile: 'An error occurred while downloading the report. Please try again.',
                title: 'Error',
                pageNotFound: 'The page you are looking for does not exist'
            },
            validation: {
                requiredField: 'This field is required',
                invalidField: 'The field format is invalid',
                notFound: 'No user found with the provided email.',
                invalidLogin: 'The credentials you entered are incorrect.',
                passwordMismatch: 'Password and Confirm Password didn\'t match.',
                acceptTerms: 'You must accept the terms and conditions'
            },
            changePassword: {
                title: 'Change password',
                warning: 'Are you sure you want to change password?',
                success: 'Please check your mailbox and follow the steps to continue the process'
            },
            downloadExcel: 'Download Excel',
            logout: 'Logout',
            loading: 'Loading...',
            watch: 'Watch',
        },
    },
    es: {
        translation: {
            clients: clients.ES,
            cards: cards.ES,
            activity: activity.ES,
            collections: collections.ES,
            datepicker: datepicker.ES,
            users: users.ES,
            details: details.ES,
            summary: summary.ES,
            management: management.ES,
            login: login.ES,
            recover: recover.ES,
            device: device.ES,
            expirations: expirations.ES,
            paymentLinks: paymentLinks.ES,
            paymentMovements: paymentMovements.ES,
            paymentLinksPosition: paymentLinksPosition.ES,
            email: email.ES,
            telephone: telephone.ES,
            fraudPrevention: fraudPrevention.ES,
            products: products.ES,
            pagination: {
                total: 'Registros',
                of: 'de',
                empty: 'No se encontraron registros',
                recordsPerPage: 'Registros por página',
                warning: `No podemos cargar más páginas.<br />
                Afina tus criterios de búsqueda<br />
                para ver más resultados.`
            },
            filter: {
                searchPlaceholder: 'Ingresá tu dato',
                search: 'Buscar',
                title: 'Filtrar',
                modal: {
                    title: 'Filtros de búsqueda',
                    date: {
                        title: 'Fecha',
                        from: 'Desde fecha',
                        to: 'Hasta fecha'
                    },
                    apply: 'Aplicar',
                    delete: 'Borrar filtros'
                }
            },
            buttons: {
                accept: 'Aceptar',
                confirm: 'Confirmar',
                cancel: 'Cancelar',
                continue: 'Continuar',
                back: 'Volver',
                block: 'Bloquear',
                unblock: 'Desbloquear',
                recoverPassword: 'Recuperar contraseña',
                unsubscribe: 'Dar de baja',
                save: 'Guardar',
                discard: 'Descartar cambios',
                reportPayment: 'Informar pago',
                reject: 'Rechazar',
                approve: 'Aprobar',
                login: 'Iniciar sesión',
                sendEmail: 'Enviar correo',
                close: 'Cerrar',
                editMail: 'Modificar Correo',
                preview: 'Vista previa',
                program: 'Programar',
                reset: 'Reiniciar búsqueda',
                modify: 'Modificar',
            },
            errors: {
                generalTitle: 'Algo no salió como esperamos',
                generalDescription: 'Lo sentimos, en este momento no fue posible completar la operación.',
                user: 'El usuario que intenta crear ya existe.',
                emailAlreadyExists: 'El correo ingresado existe para otro usuario',
                notFound: 'Ha ocurrido un error al intentar cargar el cliente.',
                invalidPassword: 'La contraseña no debe contener datos personales.',
                downloadFile: 'Ocurrió un error al descargar el reporte. Por favor intentelo nuevamente.',
                title: 'Error',
                pageNotFound: 'La página que buscas no existe'
            },
            validation: {
                requiredField: 'Este campo es obligatorio',
                invalidField: 'El formato del campo es inválido',
                notFound: 'No se encontró el usuario con el email ingresado.',
                invalidLogin: 'Las credenciales ingresadas son incorrectas.',
                passwordMismatch: 'Las contraseñas no coinciden.',
                acceptTerms: 'Debes aceptar los términos y condiciones'
            },
            changePassword: {
                title: 'Cambiar contraseña',
                warning: '¿Está seguro que quiere cambiar de contraseña?',
                success: 'Por favor revisar la casilla de mail ingresada y seguir los pasos para recuperar la contraseña.'
            },
            downloadExcel: 'Descargar Excel',
            logout: 'Cerrar sesión',
            loading: 'Cargando...',
            watch: 'Ver',
        }
    }
};

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .use(LanguageDetector)
    .init({
        resources,
        fallbackLng: 'es',
        supportedLngs: ['es', 'en'],
        detection: {
            order: ['localStorage'],
            caches: ['localStorage'],
            lookupLocalStorage: 'i18nextLng'
        },
        interpolation: {
            escapeValue: false // react already safes from xss
        },
        react: {
            bindI18n: 'languageChanged',
        }
    });

export default i18n;
